import { useLocation, useRouteMatch } from 'react-router-dom';
import { getIconColorFromLevel, getIconFromLevel } from 'sections/client-management/utils/ClientHelpers';

export const useClientFromUrl = (): {
  clientId: string;
  clientLevel: string;
  clientIcon: string;
  clientColor: string;
} => {
  const { pathname } = useLocation();
  const level = pathname ? pathname.split('/')[1] : null;

  const clientLevel = level === 'sites' || level === 'brands' || level === 'groups' ? level : null;
  const clientId = useRouteMatch<{ id: string }>({ path: ['/sites/:id', '/brands/:id', '/groups/:id'] })?.params?.id;
  const clientIcon = getIconFromLevel(clientLevel);
  const clientColor = getIconColorFromLevel(clientLevel);

  return { clientId, clientLevel, clientIcon, clientColor };
};

export default useClientFromUrl;
